module.exports = {
      id: "trending-usage",
      viewBox: "0 0 27.001 27.001",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#trending",
      toString: function () {
        return this.url;
      }
    }